import type React from "react";
import { Badge } from "../../../components/Theme/badge.tsx";
import type { IssueWithAssetRegister } from "../../../kubb";

export function IssueCancelledBadge(props: {
  issue: IssueWithAssetRegister;
}): React.ReactNode {
  const { issue } = props;
  if (issue.cancelled) return <Badge color={"zinc"}>cancelled</Badge>;
  return null;
}
